import React from "react";
import ThemeSwitch from "../ThemeSwitch";
import HpglLogo from "../../assets/HPGL-logo.png";
import HpglLogoDark from "../../assets/Hpgl-logo-dark.png";
import useThemeStore, { isDarkMode } from "../../store/themeStore";
import { Busy } from "../Busy";

const AuthPageLayout: React.FC<any> = ({ children, isBusy, busyMessage }) => {
  const isDm = useThemeStore(isDarkMode);
  return (
    <div
      className={`bg-cover bg-center bg-no-repeat bg-fixed w-full h-screen ${
        isDm ? "bg-dark" : "bg-light"
      }`}
      style={{height: 'calc(100vh)', overflow: 'auto'}}
    >
      <div className="p-4">
        <div className="flex justify-between">
          <img alt="Your Company" src={HpglLogo} className="h-10 w-12 dark:hidden" />
          <img alt="Your Company" src={HpglLogoDark} className="h-10 w-12 hidden dark:block" />
          <ThemeSwitch />
        </div>

        {children}
      </div>
      {isBusy && (
        <Busy busyMessage={busyMessage ? busyMessage : "Please wait..."} />
      )}
      <div className="container-shell-footer dark:bg-gray-800 p-1 left-0">
        <div className="w-full flex justify-center">
        <span className="m-0 text-xs text-gray-200 ">
          v{__APP_VERSION__}
        </span>
        </div>
      </div>
    </div>
  );
};

export default AuthPageLayout;
